import { useRef, type ReactNode } from "react";
import { useDrop } from "react-dnd";
import { Box } from "@mui/material";
import { LAYER_DND_TYPE } from "./SortableRecipeLayer";

type Props = {
  children: ReactNode;
};

export const LayerDropZone = ({ children }: Props) => {
  const ref = useRef<HTMLDivElement>(null);
  const [, drop] = useDrop({ accept: LAYER_DND_TYPE });

  drop(ref);

  return (
    <Box ref={ref} sx={{ flex: 1 }}>
      {children}
    </Box>
  );
};
